import React, { useRef, useState } from 'react';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';
import Dialog from './Dialog';

/**
 * Replaces window.confirm for destructive contact actions so the confirmation
 * names what is about to be removed and can show progress while it runs.
 */
export default function ConfirmDialog({
  open,
  title,
  lead,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',
  onConfirm,
  onClose,
  children,
}) {
  const [pending, setPending] = useState(false);
  const cancelRef = useRef(null);

  const handleConfirm = async () => {
    if (pending) return;
    setPending(true);
    try {
      await onConfirm?.();
    } finally {
      setPending(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={pending ? undefined : onClose}
      dismissible={!pending}
      title={title}
      lead={lead}
      initialFocusRef={cancelRef}
      footer={
        <div className={styles.dialogFoot}>
          <button
            ref={cancelRef}
            type="button"
            className={`${styles.btn} ${styles.btnGhost}`}
            onClick={onClose}
            disabled={pending}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`${styles.btn} ${tone === 'danger' ? styles.btnDanger : styles.btnPrimary}`}
            onClick={handleConfirm}
            disabled={pending}
          >
            {pending ? <span className={styles.spinner} aria-hidden="true" /> : null}
            {pending ? 'Working…' : confirmLabel}
          </button>
        </div>
      }
    >
      {children}
    </Dialog>
  );
}
